<public>

  <div id="privacy">
      <div id="privacy-form-wrapper" fxLayout="column" fxLayoutAlign="start start" fxFlex="100">
          <div id="privacy-form">
              <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutAlign="start start">

                  <div fxLayout="column" fxFlex="100">
                    <div>

                      <div style="padding: 12px;" class="jumbotron text-center" fxLayout="row" fxLayout.md="column" fxLayout.sm="column" fxLayout.xs="column">
                        <div fxFlex="20" fxLayout="column">
                          <h1 class="subHeader" style="line-height: 60px;">
                            Privacy Policy
                          </h1>
                        </div>
                        <div fxFlex="80" fxLayout="column">
                          <span class="privacy-text" style="display: inline-block !important; color: #fff; font-size: 24px; line-height: 32px; font-family: 'Raleway', sans-serif;">
                            No data is collected by Joe Moceri.
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</public>
